/* import __COLOCATED_TEMPLATE__ from './company-picture-upload.hbs'; */
import ProfilePictureUpload from 'sh-www/components/glm/fields/profile-picture-upload';

class GlmFieldsCompanyPictureUpload extends ProfilePictureUpload {}

export default GlmFieldsCompanyPictureUpload;
